import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import React, { forwardRef, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface BodyTableLineProps extends React.HTMLAttributes<HTMLElement> {
  items?: string;
  href?: string;
  event?: () => void;
  additionalClass?: string;
  children?: ReactNode;
}

export const BodyTableLine = forwardRef<HTMLElement, BodyTableLineProps>(
  (props, ref) => {
    const {
      items,
      href,
      event,
      additionalClass,
      className,
      children,
      ...restProps
    } = props;

    const navigate = useNavigate();

    const addedClass = () => {
      let preparedClass = '';
      if (additionalClass) {
        preparedClass = additionalClass;
      }
      return preparedClass;
    };

    const identEl = () => {
      return (
        <div
          ref={ref as React.Ref<HTMLDivElement>}
          onClick={() => {
            event?.();

            href && navigate(String(href));
          }}
          className={cx(
            className,
            style.BodyTableLine,
            items && style[`lineItems-${items}`],
            style[addedClass()]
          )}
          data-testid="table-row"
          {...restProps}
        >
          {children}
        </div>
      );
    };

    return identEl();
  }
);

export default BodyTableLine;
